var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"Log Out"}}),_c('div',[_vm._v(" You are logged out. "),_c('router-link',{attrs:{"to":{name: 'login'}}},[_vm._v("Log back in")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }